/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".release-invoices-dialog[_ngcontent-%COMP%]{width:450px}.release-invoices-dialog-content[_ngcontent-%COMP%]{height:100px;margin-top:16px}.release-invoices-dialog-actionbar[_ngcontent-%COMP%]{justify-content:flex-start}"];
export { styles as styles };

